import BlankCoupon from '@components/blank/BlankCoupon';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import styled from '@emotion/styled';

import useMyCoupons from './hooks/useMyCoupons';
import CouponFilter from '../../components/CouponFilter';
import CouponItem from '../../components/CouponItem';

function MyCouponFragment() {
    const {
        coupons, fetchNextPage, isEmpty, setSort, sort, isFetching,
    } = useMyCoupons();
    return (
        <Column fullWidth>
            <CouponFilter sort={sort} setSort={setSort}/>
            <Container fullWidth as='section' align='center' spacing={16}>
                {coupons?.map((coupon, i) => (
                    <CouponItem coupon={coupon}
                        key={coupon.couponId} />
                ))}
                {isEmpty && (<BlankCoupon/>)}
                <InfinityScrollTrigger trigger={fetchNextPage} />
                {isFetching && (<Loading size='small'/>)}
            </Container>
        </Column>
    );
}

const Container = styled(Column)`
    padding: 0 20px;  
`;

export default MyCouponFragment;
